import { Dropdown, Space } from 'antd';
import { DownOutlined } from '@ant-design/icons';

import { BreadcrumbDropdownProps } from './breadcrumbDropdown';

const BreadcrumbDropdownClient: React.FC<BreadcrumbDropdownProps> = ({
  items,
  label,
}) => {
  return (
    <Dropdown
      menu={{ items }}
      trigger={['click']}
      overlayClassName="breadcrumb-dropdown"
    >
      <a onClick={(e) => e.preventDefault()}>
        <Space>
          {label}
          <DownOutlined style={{ fontSize: '12px' }} />
        </Space>
      </a>
    </Dropdown>
  );
};

export default BreadcrumbDropdownClient;
